module.exports = __webpack_public_path__ + "sprite/win-sign.png";


//////////////////
// WEBPACK FOOTER
// ./sprite/win-sign.png
// module id = 130
// module chunks = 3